import {POST, GET} from "@/services/gateway";

const list = () => {
  return GET('dropbox/shared-folder/backupsetings');
}

const updateAutoAdd = ({seatType, autoAdd}) => {
  return POST('dropbox/shared-folder/backupsetings', {
    seatType, autoAdd
  })
}


export {
  list,
  updateAutoAdd
}
